import { SorterResult, FilterValue, TablePaginationConfig, TableCurrentDataSource } from 'antd/es/table/interface';

export const HELIX_TEMPLATES_BASE_PATH = "/core-v1/helixtemplates";

export const READ_HELIX_TEMPLATES_PERMISSION = {
  customerApplication: "Mercury",
  permissionName: "Helix Templates",
  action: "read" as const,
};

export const CREATE_HELIX_TEMPLATES_PERMISSION = {
  customerApplication: "Mercury",
  permissionName: "Helix Templates",
  action: "create" as const,
};

export const EDIT_HELIX_TEMPLATES_PERMISSION = {
  customerApplication: "Mercury",
  permissionName: "Helix Templates",
  action: "edit" as const,
};

export const DELETE_HELIX_TEMPLATES_PERMISSION = {
  customerApplication: "Mercury",
  permissionName: "Helix Templates",
  action: "delete" as const,
};

export const buildHelixTemplateUrl = (baseUrl: string, id?: string) => {
  const url = `${baseUrl.replace(/\/$/, "")}${HELIX_TEMPLATES_BASE_PATH}`;
  return id ? `${url}/${id}` : url;
};

export type HelixTemplate = {
  _id?: string;
  id?: string;
  helixId: string;
  name: string;
  description: string;
};

export type EditingState = {
  isEditing: boolean;
  editingRow?: HelixTemplate | null;
  isDeleting: boolean;
};

export type TableHandlers = {
  handleChangeTable: (
    pagination: TablePaginationConfig,
    filters: Record<string, FilterValue | null>,
    sorter: SorterResult<HelixTemplate> | SorterResult<HelixTemplate>[],
    extra: TableCurrentDataSource<HelixTemplate>
  ) => void;
  handleClickEdit: (record: HelixTemplate) => void;
  handleClickDelete: (record: HelixTemplate) => void;
  handleFinishDelete: (submitted: boolean) => Promise<void>;
};
